import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { useLandingContent } from '@/features/admin/content/landingContent'

/**
 * Barra de anuncio superior del landing. Se muestra solo si está habilitada
 * desde la sección administrativa (Contenido del landing → Anuncio). ✅ EN VIVO
 */
export function AnnouncementBar() {
  const { announcement } = useLandingContent()
  if (!announcement.enabled) return null

  return (
    <div className="bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-5 lg:px-6 py-2.5 flex items-center justify-center gap-3 text-sm">
        <span className="text-center">{announcement.text}</span>
        {announcement.ctaLabel && (
          <Link
            to={announcement.ctaHref || '/registro'}
            className="inline-flex items-center gap-1 font-semibold text-primary hover:underline shrink-0"
          >
            {announcement.ctaLabel}
            <ArrowRight className="size-3.5" />
          </Link>
        )}
      </div>
    </div>
  )
}
